module.exports = __webpack_public_path__ + "img/login01b.02bbf786.png";